import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/icons/helpdesk.svg'


const _hoisted_1 = { class: "app-sidebar" }
const _hoisted_2 = { class: "app-widget" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Need help icon"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "need-help" }, "Need Help?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, " We are here to assist you. Please click Contact Us to connect with P&A Group's Participant Support Center. ", -1)
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentList = _resolveComponent("DocumentList")!
  const _component_BenefitsTotal = _resolveComponent("BenefitsTotal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.name === _ctx.routesPath.documents)
      ? (_openBlock(), _createBlock(_component_DocumentList, { key: 0 }))
      : _createCommentVNode("", true),
    (
        _ctx.$route.name === _ctx.routesPath.payments ||
        _ctx.$route.name === _ctx.routesPath.benefits ||
        _ctx.$route.name === _ctx.routesPath.cardDetails
      )
      ? (_openBlock(), _createBlock(_component_BenefitsTotal, {
          key: 1,
          benefitHeader: _ctx.benefitHeader,
          showBenefitHeader: _ctx.showBenefitHeader
        }, null, 8, ["benefitHeader", "showBenefitHeader"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("a", {
        class: "contact-us",
        href: _ctx.links.contactUs,
        target: "_blank"
      }, "Contact us", 8, _hoisted_6)
    ])
  ]))
}